export default (params) => ({
  trigger: {
    name: 'content_blocks.usps.select_usp',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      url: {
        type: 'string',
      },
      redirect: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'header',
          'mid-page',
          'footer',
          'order_block',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'select_usp',
    },
  },
});
